import React, { Component, Fragment } from "react";

export default class BenefitBlock extends Component {
  render() {
    const { benefit, index } = this.props;
    const { sInit, sFirstName, sLastName, sRelation } = benefit;
    const seq = index + 1;
    const init1 = sInit ? sInit.label : "";
    const sFirstName1 = sFirstName ? sFirstName : "ทายาทโดยธรรม";
    const sLastName1 = sLastName ? sLastName : "";
    const benefit1Fullname = `${init1} ${sFirstName1} ${sLastName1}`;

    return (
      <div className="form-group">
        <label>ผู้รับผลประโยชน์</label>
        <Fragment>
          <label>ผู้รับผลประโยชน์คนที่ {seq}</label>
          <p>{benefit1Fullname}</p>
          {sRelation && sRelation.label ? (
            <Fragment>
              <label>ความสัมพันธ์</label>
              <p>{sRelation && sRelation.label}</p>
            </Fragment>
          ) : (
            ""
          )}
        </Fragment>{" "}
      </div>
    );
  }
}
